import { BlockBlobClient } from '@azure/storage-blob';
import { toast } from 'react-toastify';

import user from '@/api/user';

const { getSASToken } = user();

const mode = import.meta.env.VITE_MODE;
const baseUrl = import.meta.env.VITE_AZURE_SOURCE;

export const uploadBlob = async (filesAttachment) => {
	let idx = 0;
	const res = [];
	for (const f of filesAttachment) {
		const file = f.file;
		const fDest = mode === 'production' ? 'masterUpload' : 'upload';
		const bName = `${fDest}/${file.name}`;
		const isPrivate = !!f.privilegelevelid?.find((p) => p.id === 99 && !!p.value);
		const cName = isPrivate ? 'bds-docs' : 'bds-docs-public';

		const formData = new FormData();
		formData.append('container_name', cName);
		formData.append('blob_name', bName);
		const sizeInMB = (file.size / (1024 * 1024));
		const expiryMinutes = sizeInMB * 10; // 100mb - 100minute
		const expirySeconds = Math.round(expiryMinutes * 60);

		formData.append('expiry_time', expirySeconds > 10 ? expirySeconds : 30 );

		const sasToken = await getSASToken(formData);
		if (!sasToken.data.sas_token) return;

		const url = `${baseUrl}/${cName}/${fDest}/${file.name}`;
		const blockBlobClient = new BlockBlobClient(
			`${url}?${sasToken.data.sas_token}` // A SAS should start with "?"
		);

		try {
			const arrayBuffer = await file.arrayBuffer();
			const resFile = await blockBlobClient.uploadData(arrayBuffer, {
				maxSingleShotSize: 4 * 1024 * 1024,
				blobHTTPHeaders: { blobContentType: file.type }, // set mimetype
			});
			res.push(resFile._response);
			// if (resFile._response.status === 201) {}
		} catch (error) {
			toast.error(`${error.statusCode} - ${error.code}`);
			return { error, idx };
		}
		idx++;
	}
	return res;
};
